import React from 'react'

import styles from './ChoicePopup.module.scss'
import { ReactComponent as XIcon } from 'assets/img/close.svg'
import ReactModal from 'react-modal';
import { useAtom } from 'jotai';
import { choiceTopPopupAtom, } from 'showMessageMenuAtom';
import { ReactComponent as TippyIcon } from 'assets/img/tooltip.svg';
import { ReactComponent as GearIcon } from 'assets/img/workflow.svg';
import { ReactComponent as SegmentIcon } from "assets/img/filter.svg";
import { toast } from 'react-toastify';


const ChoicePopup = (
    {
        choicefn,
        workflowEvent
    }:
        {
            choicefn: any,
            workflowEvent: any
        }
) => {

    const [isChoiceOpen, setIsChoiceOpen] = useAtom(choiceTopPopupAtom)
    const closeDialog = () => {
        setIsChoiceOpen(false)
    }


    return (
        <ReactModal
            isOpen={isChoiceOpen}
            className={styles.ChoicePopup}
            style={{
                content: {
                    width: "400px",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                }
            }}
        >
            <div className={styles.ChoicePopup__header}>
                <h1>Add next step to workflow</h1>
                <span onClick={closeDialog}>
                    <XIcon />
                </span>
            </div>

            <div className={styles.ChoicePopup__body}>
                <div
                    onClick={() => choicefn('action')}
                    className={styles.ChoicePopup__body__Action}
                >
                    <div className={styles.tooltipBody}>
                        <div className={styles.tooltip}>
                            <div className={styles.tooltip__icon}><TippyIcon /></div>
                            <span
                                className={styles.tooltipText}
                                data-tooltip={`Actions are tasks your workflow performs.`}
                            >
                            </span>
                        </div>

                    </div>
                    <div className={styles.ChoicePopup__body__Action__head}>
                        <div className={styles.ChoicePopup__body__Action__head__icon}><GearIcon /></div>
                        <label>Action</label>
                    </div>
                </div>

                <div
                    onClick={() => {
                        if (workflowEvent && workflowEvent.event_resource_details) {
                            choicefn('filter')
                        } else {
                            toast('Workflow trigger is required', {
                                type: 'error',
                                autoClose: 3000,
                                theme: "light",
                                hideProgressBar: true,
                                position: "top-center",
                            });
                        }
                    }}
                    className={styles.ChoicePopup__body__Action}
                >
                    <div className={styles.tooltipBody}>
                        <div className={styles.tooltip}>
                            <div className={styles.tooltip__icon}><TippyIcon /></div>
                            <span
                                className={styles.tooltipText}
                                data-tooltip={`Filters help you set specific conditions that must be met for your workflow steps to proceed.`}
                            >
                            </span>
                        </div>

                    </div>
                    <div className={styles.ChoicePopup__body__Action__head}>
                        <div className={styles.ChoicePopup__body__Action__head__icon}><SegmentIcon /></div>
                        <label>Filter</label>
                    </div>
                </div>
            </div>

            <div className={styles.ChoicePopup__footer}>
                <button className={styles.ChoicePopup__footer__cancel}
                    onClick={closeDialog}
                >
                    Close
                </button>
            </div>
        </ReactModal>
    )
}

export default ChoicePopup
